import { axiosFactory, errorHandler } from '@/configs/axios'

const state = () => ({
  imei: null,
  markerList: [],
  selectedImei: null,
  selectedVehicle: null,
  selectedTags: [],
  selectedStatus: [],
  selectedVehicleName: null,
})

const getters = {
  imei(state) {
    return state.imei
  },
  markerList(state) {
    return state.markerList
  },
  selectedImei(state) {
    return state.selectedImei
  },
  selectedVehicle(state) {
    return state.selectedVehicle
  },
  selectedTags(state) {
    return state.selectedTags
  },
  selectedStatus(state) {
    return state.selectedStatus
  },
  selectedVehicleName(state) {
    return state.selectedVehicleName
  },
  combinedSelected(state) {
    return {
      selectedVehicle: state.selectedVehicle,
      selectedTags: state.selectedTags,
      selectedStatus: state.selectedStatus,
      selectedVehicleName: state.selectedVehicleName,
    }
  },
}
const mutations = {
  SET_IMEI(state, payload) {
    state.imei = {
      imei: payload,
    }
  },
  SET_MARKER_LIST(state, payload) {
    state.markerList = payload
  },
  SET_SELECTED_IMEI(state, payload) {
    state.selectedImei = payload
  },
  SET_VEHCILE_LIST(state, payload) {
    state.selectedVehicle = payload
  },
  SET_VEHCILE_TAGS(state, payload) {
    state.selectedTags = payload
  },
  SET_VEHCILE_STATUS(state, payload) {
    state.selectedStatus = payload
  },
  SET_VEHICLE_NAME(state, payload) {
    state.selectedVehicleName = payload
  },
}
const actions = {
  getIMEI(context, payload) {
    return axiosFactory()
      .auth.get('api/customer-vehicles/v1/has-hardware/')
      .then((res) => {
        let imeiList
        if (res.data.length > 0) {
          imeiList = res.data.map((item) => {
            return item.hardware.imei
          })
          context.commit('SET_IMEI', imeiList)
          context.commit('SET_MARKER_LIST', res.data)
          return true
        }
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
  liveTracking(context, payload) {
    const tagQuery = payload.selectedTags.length
      ? `company_vehicle_tags__id__in=${payload.selectedTags.join(',')}`
      : ''
    const searchQuery = payload.selectedVehicle
      ? 'id__in=' + payload.selectedVehicle
      : ''

    const statusQuery = payload.selectedStatus.length
      ? 'traffic_status__in=' + payload.selectedStatus
      : ''
    const vehicleNameQuery = payload.selectedVehicleName
      ? `vehicle__id__in=${payload.selectedVehicleName}`
      : ''
    const queryParams = [searchQuery, tagQuery, statusQuery, vehicleNameQuery]
      .filter(Boolean)
      .join('&')
    const url = `trackings/${queryParams ? `?${queryParams}` : ''}`

    return axiosFactory()
      .auth.get(url)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        return false
        // errorHandler(error);
      })
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}
